import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CHECKOUT_URLS, PRICES, purchaseIncludes, IMAGES } from '../data/content';
export function PurchaseSection() {
  const [isArgentina, setIsArgentina] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 3000);
    fetch('https://ipapi.co/json/', {
      signal: controller.signal
    }).then(res => res.json()).then(data => {
      if (data?.country_code === 'AR') setIsArgentina(true);
    }).catch(() => {
      /* Si la detección falla se mantiene el precio en USD. */
    }).finally(() => window.clearTimeout(timeout));
    return () => {
      window.clearTimeout(timeout);
      controller.abort();
    };
  }, []);
  const price = isArgentina ? PRICES.AR : PRICES.INTL;
  const checkoutUrl = isArgentina ? CHECKOUT_URLS.AR : CHECKOUT_URLS.INTL;
  return <section id="comprar" className="bg-fil-terra px-4 sm:px-6 lg:px-8 py-14 sm:py-20 scroll-mt-8" data-id="element-145" data-mp="y64vskuiu0n6">
      <div className="max-w-2xl mx-auto text-center" data-id="element-146" data-mp="1276u8zgm68o3">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight mb-4" data-id="element-147" data-mp="127qggsdarj7x">
          Comienza hoy con El Arte de la Filigrana
        </h2>
        

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-fil-card rounded-[2rem] p-6 sm:p-10 shadow-xl text-left" data-id="element-148" data-mp="1c6nxzbcb2chf">
          <div className="flex justify-center mb-6" data-id="element-149" data-mp="1pxt4mxe3c519">
            <img src={IMAGES.portada} alt="Portada de El Arte de la Filigrana" className="w-full max-w-[180px] sm:max-w-[200px] h-auto" data-id="element-150" data-mp="1uwnj5n50z7fk" />
          </div>
          <p className="font-serif text-xl sm:text-2xl font-bold text-fil-text text-center uppercase tracking-wide mb-6" data-id="element-151" data-mp="1zx1rl6ajgje4">
            El Arte de la Filigrana
          </p>

          <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2.5 mb-8" data-id="element-152" data-mp="1f6xxh0dateez">
            {purchaseIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-153" data-mp="1a8e8er3ermie">
                <CheckIcon size={16} strokeWidth={3} className="text-fil-sage-dark shrink-0 mt-1" data-id="element-154" data-mp="1owhj2dsebmdj" />
                <span className="text-sm sm:text-base text-fil-text/85 font-medium leading-snug" data-id="element-155" data-mp="1k4pnfouduqgj">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="flex flex-col items-center gap-1 mb-8" data-id="element-156" data-mp="1sxkvsrf5d2aj">
            <span className="text-base text-fil-muted line-through font-serif" data-id="element-157" data-mp="1sxb5t3u3qv4u">
              {price.previous}
            </span>
            <span className="text-4xl sm:text-5xl font-bold text-fil-terra font-serif leading-none" data-id="element-158" data-mp="22vqw54lb20da">
              {price.current}
            </span>
            <span className="text-xs sm:text-sm text-fil-taupe font-medium mt-2" data-id="element-159" data-mp="dhlu9z01c4j9">
              Pago único · Sin suscripciones
            </span>
          </div>

          <motion.a href={checkoutUrl} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} transition={{
          duration: 0.12,
          ease: [0.23, 1, 0.32, 1]
        }} className="block w-full py-5 px-6 rounded-full bg-fil-terra text-white font-bold text-base sm:text-lg uppercase tracking-wider text-center hover:bg-fil-terra-dark transition-colors duration-200 ease-out mb-5" data-id="element-160" data-mp="2k5b8ah1re27n">
            Quiero acceder ahora
          </motion.a>

          <p className="flex items-center justify-center gap-2 text-xs sm:text-sm text-fil-taupe font-medium" data-id="element-161" data-mp="25h8339vjiujw">
            
            
          </p>
        </motion.div>
      </div>
    </section>;
}